import { css } from '../../styles/theme';

export const StylesDS = css``;
